const getters = {
  portalUrl: (state) => state.app.portalUrl,
  idCode: (state) => state.app.idCode,
  loading: (state) => state.app.loading,
  mainDOMRect: (state) => state.app.mainDOMRect,
  pressTestUrl: (state) => state.app.pressTestUrl,
  h5previewUrl: (state) => state.app.h5previewUrl,
  projectName: (state) => state.app.projectName,
  windowTitle: (state) => state.app.windowTitle,
  sidebar: (state) => state.app.sidebar,
  tagWel: (state) => state.app.tagWel,
  language: (state) => state.app.language,
  visLanguage: (state) => state.app.visLanguage,
  themeColor: (state) => state.app.themeColor,
  user: (state) => state.login.userInfo,
  imageBaseUrl: (state) => state.app.imageBaseUrl,
  menus: (state) => state.login.menus,
  routes: (state) => state.login.routes,
  access_token: (state) => state.login.access_token,
  refresh_token: (state) => state.login.refresh_token,
  defaultUserPhoto: (state) => state.app.defaultUserPhoto,
  tenantInfo: (state) => state.login.tenantInfo,
  tenantConfig: (state) => state.login.tenantConfig,
  clinicInfo: (state) => state.login.clinicInfo,
  herbsInfo: (state) => state.login.herbsInfo,
  hisHerbsInfo: (state) => state.login.hisHerbsInfo,
  hisProjectInfo: (state) => state.login.hisProjectInfo,
  herbsRestraintInfo: (state) => state.login.herbsRestraintInfo,
  herbsRestraintInfoIndex: (state) => state.login.herbsRestraintInfoIndex,
  optionData: (state) => state.login.optionData,
  hisOption: (state) => state.login.hisOption,
  herbUnitConvert: (state) => state.login.herbUnitConvert,
  symptoms: (state) => state.login.symptoms,
  feeConfig: (state) => state.login.feeConfig,
  allData: (state) => state.app.allData,
  additionalItemCV: (state) => state.app.additionalItemCV,
  loginType: (state) => state.login.loginType
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js